import React from "react";
import { useDispatch } from "react-redux";
import { Button, Modal } from "semantic-ui-react";
import { statDelete } from "../../../store/actions/statsPhotosAction";
import "../../../pages/Admin.css";
const Delete = (props) => {
  const dispatch = useDispatch();
  return (
    <div className="Delete-Modal">
      <Modal className="delete-popup delete-stat" open={props.deleteId}>
        <Modal.Content>
          <p className="p1">Are you sure want to delete this?</p>
          <p className="p2">this process cannot be undone.</p>
          <div className="delete-modal-footer">
            <Button name="closeButton" content="Cancel" onClick={props.close} />
            <Button
              color="red"
              name="saveButton"
              content="Delete"
              onClick={() => {
                dispatch(statDelete(props.deleteUrl, props.deleteId));
                props.close();
              }}
            />
          </div>
        </Modal.Content>
      </Modal>
    </div>
  );
};

export default Delete;
